import React, { useEffect } from "react";
import PrevButton from "components/PrevButton";

import { useFormattedMessage, useSideModalScrollToTop } from "hooks";

const messages = {
    orderExpiredHeading: "dashboard_orderExpired",
    orderExpiredTitle: "order_expired_title",
    orderExpiredContent: "order_expired_content",
    boEditSuccessButtonText: "close_btn",
};

const OrderExpired = ({
    heading,
    title,
    content,
    setCloseTitle,
    buttonText,
    onButtonClick,
    isOrderItemClicked,
    onBack,
    // backSlideEffect = "",
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    useEffect(() => {
        setCloseTitle && setCloseTitle(heading || formatMessage(messages.orderExpiredHeading));
    }, []);

    return (
        <>
            <div className={`order-expired`}>
                {/* <img className="" src={images.timer} alt="" /> */}
                <h3 className="text-center">{title || formatMessage(messages.orderExpiredTitle)}</h3>
                <p className="body-mdium">{content || formatMessage(messages.orderExpiredContent)}</p>
                <button className="mw-100 mt-30" onClick={onButtonClick}>
                    {buttonText || formatMessage(messages.boEditSuccessButtonText)}
                </button>
            </div>
            {isOrderItemClicked && (
                <div className="bottom-bar-container">
                    <PrevButton onClick={onBack} />
                </div>
            )}
        </>
    );
};

export default OrderExpired;
